import { useEffect } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { TipsHero } from './components/TipsHero';
import { PreparingYourBuilding } from './components/PreparingYourBuilding';
import { PricingStrategies } from './components/PricingStrategies';
import { MarketingTips } from './components/MarketingTips';
import { NegotiationTactics } from './components/NegotiationTactics';
import { LegalConsiderations } from './components/LegalConsiderations';
import { TaxImplications } from './components/TaxImplications';
import { TimingYourSale } from './components/TimingYourSale';
import { DueDiligence } from './components/DueDiligence';
import { ClosingProcess } from './components/ClosingProcess';
import { CommonMistakes } from './components/CommonMistakes';
import { TipsFinalCTA } from './components/TipsFinalCTA';

export default function TipsForSellingApartmentBuilding() {
  useEffect(() => {
    // Set document title
    document.title = 'Expert Tips for Selling an Apartment Building - Maximize Your Sale Price';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Discover expert tips for selling an apartment building successfully. Learn pricing strategies, marketing tactics, negotiation tips, legal considerations, and how to maximize your sale price. Complete guide for apartment building owners.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Discover expert tips for selling an apartment building successfully. Learn pricing strategies, marketing tactics, negotiation tips, legal considerations, and how to maximize your sale price. Complete guide for apartment building owners.';
      document.head.appendChild(meta);
    }

    // Set meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'tips for selling an apartment building, apartment building sale tips, selling multifamily property, apartment building pricing, real estate investment tips, commercial property sale');
    } else {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      metaKeywords.setAttribute('content', 'tips for selling an apartment building, apartment building sale tips, selling multifamily property, apartment building pricing, real estate investment tips, commercial property sale');
      document.head.appendChild(metaKeywords);
    }

    // Set canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://sellapartmentscash.com/tips-for-selling-apartment-building');
    } else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', 'https://sellapartmentscash.com/tips-for-selling-apartment-building');
      document.head.appendChild(canonical);
    }

    // Add structured data for Article
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "Expert Tips for Selling an Apartment Building - Maximize Your Sale Price",
      "description": "Comprehensive guide with expert tips for selling an apartment building successfully, including pricing strategies, marketing tactics, and negotiation tips.",
      "author": {
        "@type": "Organization",
        "name": "Sell Apartments Cash"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Sell Apartments Cash",
        "logo": {
          "@type": "ImageObject",
          "url": "https://sellapartmentscash.com/logo.png"
        }
      },
      "datePublished": "2024-01-15",
      "dateModified": new Date().toISOString().split('T')[0]
    };

    // Add structured data script
    let structuredDataScript = document.querySelector('script[type="application/ld+json"]');
    if (structuredDataScript) {
      structuredDataScript.textContent = JSON.stringify(structuredData);
    } else {
      structuredDataScript = document.createElement('script');
      structuredDataScript.type = 'application/ld+json';
      structuredDataScript.textContent = JSON.stringify(structuredData);
      document.head.appendChild(structuredDataScript);
    }

    // Cleanup function
    return () => {
      const elementsToRemove = [
        document.querySelector('meta[name="description"]'),
        document.querySelector('meta[name="keywords"]'),
        document.querySelector('link[rel="canonical"]'),
        document.querySelector('script[type="application/ld+json"]')
      ].filter(element => {
        if (!element) return false;
        const content = element.getAttribute('content') || element.getAttribute('href') || element.textContent || '';
        return content.includes('tips for selling') || content.includes('tips-for-selling-apartment-building');
      });
      
      elementsToRemove.forEach(element => element?.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <TipsHero />
      <PreparingYourBuilding />
      <PricingStrategies />
      <MarketingTips />
      <NegotiationTactics />
      <LegalConsiderations />
      <TaxImplications />
      <TimingYourSale />
      <DueDiligence />
      <ClosingProcess />
      <CommonMistakes />
      <TipsFinalCTA />
      <Footer />
    </div>
  );
}